/* LOVE LACE — tabbed mega menu: hover/focus a category to swap the panel,
   images load only when a panel is first shown, and a "Find a category"
   search over every menu link (desktop mega + mobile menu). */
(function () {
  'use strict';
  var d = document;

  function hydrate(scope) {
    if (!scope) return;
    scope.querySelectorAll('img[data-src]').forEach(function (img) {
      if (img.getAttribute('data-srcset')) img.setAttribute('srcset', img.getAttribute('data-srcset'));
      img.src = img.getAttribute('data-src');
      img.removeAttribute('data-src');
    });
  }

  /* ---- index of every category link, for the finder ---- */
  var index = null;
  function buildIndex() {
    if (index) return index;
    index = []; var seen = {};
    d.querySelectorAll('[data-ll-mm]').forEach(function (mm) {
      var top = (mm.querySelector('.ll-mm__eyebrow') || {}).textContent || '';
      mm.querySelectorAll('[data-ll-mm-panel]').forEach(function (p) {
        var cat = (p.querySelector('.ll-mm__title') || {}).textContent || '';
        var head = p.querySelector('.ll-mm__head a');
        if (head && !seen[head.getAttribute('href')]) { seen[head.getAttribute('href')] = 1; index.push({ t: cat.trim(), u: head.getAttribute('href'), p: top.trim() }); }
        p.querySelectorAll('.ll-mm__links a').forEach(function (a) {
          var u = a.getAttribute('href');
          if (seen[u]) return; seen[u] = 1;
          index.push({ t: a.textContent.trim(), u: u, p: cat.trim() });
        });
      });
    });
    return index;
  }
  function esc(s) { return s.replace(/[&<>"]/g, function (c) { return { '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]; }); }
  function render(box, q) {
    var words = q.toLowerCase().split(/\s+/).filter(Boolean);
    var hits = buildIndex().filter(function (x) {
      var hay = (x.t + ' ' + x.p).toLowerCase();
      return words.every(function (w) { return hay.indexOf(w) > -1; });
    }).slice(0, 30);
    var re = new RegExp('(' + words.map(function (w) { return w.replace(/[.*+?^${}()|[\]\\]/g, '\\$&'); }).join('|') + ')', 'ig');
    box.innerHTML = hits.length
      ? '<p class="ll-mm__results-head">' + hits.length + (hits.length === 30 ? '+' : '') + ' categories</p><ul class="ll-mm__hits" role="list">' +
        hits.map(function (x) { return '<li><a href="' + esc(x.u) + '"><small>' + esc(x.p) + '</small>' + esc(x.t).replace(re, '<mark>$1</mark>') + '</a></li>'; }).join('') + '</ul>'
      : '<p class="ll-mm__none">No category matches “' + esc(q) + '”.</p>';
  }

  /* ---- desktop mega ---- */
  function initMega(mm) {
    if (mm.__llmm) return; mm.__llmm = true;
    var tabs = Array.prototype.slice.call(mm.querySelectorAll('[data-ll-mm-tab]'));
    var panels = Array.prototype.slice.call(mm.querySelectorAll('[data-ll-mm-panel]'));
    var results = mm.querySelector('[data-ll-mm-results]');
    var find = mm.querySelector('[data-ll-mm-find]');
    var feature = mm.querySelector('.ll-mm__feature');
    var current = '0', timer = null;

    function show(i) {
      if (find && find.value) { find.value = ''; if (results) results.hidden = true; }
      if (i === current && !(results && !results.hidden)) return;
      current = i;
      tabs.forEach(function (t) { t.classList.toggle('is-active', t.getAttribute('data-ll-mm-tab') === i); });
      panels.forEach(function (p) {
        var on = p.getAttribute('data-ll-mm-panel') === i;
        p.hidden = !on;
        p.classList.remove('is-in');
        if (on) { hydrate(p); void p.offsetWidth; p.classList.add('is-in'); }
      });
    }
    tabs.forEach(function (t) {
      var i = t.getAttribute('data-ll-mm-tab');
      t.addEventListener('mouseenter', function () { clearTimeout(timer); timer = setTimeout(function () { show(i); }, 60); });
      t.addEventListener('mouseleave', function () { clearTimeout(timer); });
      t.addEventListener('focus', function () { show(i); });
    });

    var item = mm.closest('[data-ll-mega-item]');
    function warm() {
      hydrate(feature);
      panels.forEach(function (p) { if (!p.hidden) hydrate(p); });
    }
    if (item) { item.addEventListener('mouseenter', warm); item.addEventListener('focusin', warm); }

    if (find && results) {
      find.addEventListener('input', function () {
        var q = find.value.trim();
        if (q.length < 2) {
          results.hidden = true;
          panels.forEach(function (p) { p.hidden = p.getAttribute('data-ll-mm-panel') !== current; });
          return;
        }
        render(results, q);
        panels.forEach(function (p) { p.hidden = true; });
        results.hidden = false;
      });
      find.addEventListener('keydown', function (e) {
        if (e.key === 'Enter') { var a = results.querySelector('a'); if (a && !results.hidden) { e.preventDefault(); location.href = a.href; } }
      });
    }
  }

  /* ---- mobile finder + one-open-at-a-time categories ---- */
  function initMobile() {
    var nav = d.querySelector('[data-ll-mnav]');
    if (!nav || nav.__llmm) return; nav.__llmm = true;
    var find = nav.querySelector('[data-ll-mm-find]');
    var box = nav.querySelector('[data-ll-mm-results]');
    if (find && box) {
      find.addEventListener('input', function () {
        var q = find.value.trim();
        var on = q.length >= 2;
        nav.classList.toggle('is-finding', on);
        box.hidden = !on;
        if (on) render(box, q);
      });
    }
    nav.addEventListener('toggle', function (e) {
      var t = e.target;
      if (!t.matches || !t.matches('.ll-mcat') || !t.open) return;
      nav.querySelectorAll('.ll-mcat[open]').forEach(function (o) { if (o !== t) o.open = false; });
      setTimeout(function () {
        var r = t.getBoundingClientRect(), body = nav.querySelector('.ll-mnav__body');
        if (body && (r.top < 120 || r.top > window.innerHeight * .6)) body.scrollBy({ top: r.top - 130, behavior: 'smooth' });
      }, 60);
    }, true);
  }

  function init() {
    d.querySelectorAll('[data-ll-mm]').forEach(initMega);
    initMobile();
  }
  if (d.readyState === 'loading') d.addEventListener('DOMContentLoaded', init); else init();
  d.addEventListener('shopify:section:load', function () { index = null; init(); });
})();
